import styled from "styled-components";

export const InputWrapper = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  flex-direction: column;
  p {
    width: 100%;
  }
`;
export const Label = styled.label`
  color: var(--font-color-blue002e5c);
  font-feature-settings: "clig" off, "liga" off;
  font-family: var(--general-label-font-family);
  font-size: var(--general-label-font-size);
  font-weight: var(--font-weight-bold);
  line-height: 150%;
  display: flex;
  /* justify-content: space-between; */
  width: 100%;
  span:nth-child(2) {
    color: var(--font-color-slate99abbe);
    font-size: var(--general-small-label-font-size);
    font-style: normal;
    font-weight: var(--general-small-label-font-weight);
    line-height: 150%;
  }
`;
export const Input = styled.input`
  width: 312px;
  border-radius: 5px;
  border: ${(props) =>
    props.error
      ? "1px solid rgba(241, 88, 94, 1)"
      : "1px solid var(--Gray-40, #E1E1E7)"};
  background: var(--White-100, #fff);
  height: 48.13px;
  padding-left: 16px;
  color: var(--font-color-blue002e5c) !important;
  ::placeholder {
    color: ${(props) =>
      props.isDisabled
        ? "var(--Gray-100, #9e9ead) !important"
        : "#99ABBE !important"};
    font-size: var(--general-input-font-size);
    line-height: 32px;
    font-weight: var(--general-input-font-weight);
    padding-left: 5px;
  }
  :focus {
    border-radius: 5px;
    border: ${(props) =>
      props.error
        ? "1px solid rgba(241, 88, 94, 1)"
        : "1px solid var(--blues-blue-3, #99B7EF)"};
    background: var(--Blue-10, #f3f6f9);
  }
`;
export const Error = styled.p`
  display: flex;
  text-align: left !important;
  color: var(--font-color-red) !important;
  font-size: var(--general-error-font-size) !important;
  font-weight: var(--general-error-font-weight);
  justify-content: flex-start !important;
  align-items: flex-start !important;
  width: 100%;
  padding: 0 !important;
`;
export const CustomIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 8%;
  transform: translateY(-50%);
`;
